import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { EquipmentWithType } from '../../components/DeficiencyDetailsExpansionPanel/DeficiencyDetailsExpansionPanel';
import { rootStore } from '../../mobx-models/Root';
import { BORER_DESCRIPTION } from '../../utilities/constants';
import { EquipmentTypeCollection } from '../EquipmentType/queryBuilder';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { EquipmentCollection, EquipmentDocument } from './queryBuilder';

export const useEquipment = () => {
  const equipmentCollection: EquipmentCollection = useRxCollection(RxdbCollectionName.EQUIPMENT);
  const equipmentTypeCollection: EquipmentTypeCollection = useRxCollection(
    RxdbCollectionName.EQUIPMENT_TYPE,
  );

  const [equipmentInitialized, setCollectionsInitialized] = useState(false);

  useEffect(() => {
    if (equipmentCollection) setCollectionsInitialized(true);
  }, [equipmentCollection]);

  const listEquipment = async (): Promise<EquipmentDocument[]> => {
    if (!equipmentCollection) {
      return [];
    }

    // Pull Equipment
    let allEquipment;
    try {
      allEquipment = await equipmentCollection
        .find({
          selector: {
            isActive: true,
          },
        })
        .exec();
    } catch (error) {
      console.log('🚀 ~ file: useEquipment.ts ~ line 28 ~ listEquipment ~ error', error);
      throw error;
    }

    return allEquipment;
  };

  const listEquipmentOfType = async (equipmentTypeId: string): Promise<EquipmentDocument[]> => {
    if (!equipmentCollection) {
      return [];
    }

    // Pull Equipment
    let allEquipmentOfType;
    try {
      allEquipmentOfType = await equipmentCollection
        .find({ selector: { equipmentTypeId, isActive: true } })
        .exec();
    } catch (error) {
      console.log('🚀 ~ file: useEquipment.ts ~ line 28 ~ listEquipment ~ error', error);
      throw error;
    }

    return allEquipmentOfType;
  };

  const listAssignedEquipment = async (equipmentTypeId: string): Promise<EquipmentWithType[]> => {
    if (!equipmentCollection || !equipmentTypeCollection) {
      return [];
    }

    const equipmentTypeDocument = await equipmentTypeCollection
      .findOne({
        selector: {
          id: equipmentTypeId,
        },
      })
      .exec();

    const isBorer = equipmentTypeDocument?.description === BORER_DESCRIPTION;

    let assignedEquipment;
    // Only return assigned borer
    if (isBorer) {
      try {
        assignedEquipment = await equipmentCollection
          .findOne({ selector: { id: rootStore.equipment.selectedBorerId } })
          .exec();

        assignedEquipment = [
          {
            ...assignedEquipment,
            assignedBorerEquipmentId: rootStore.equipment.selectedBorerId,
            equipmentTypeId,
            longName: assignedEquipment?.longName,
            isBorer: true,
            id: assignedEquipment?.id,
          },
        ];
      } catch (error) {
        console.log('🚀 ~ useEquipment.ts ~ line 107 ~ error', error);
        throw error;
      }
    } else {
      // Pull Equipment
      try {
        assignedEquipment = await equipmentCollection
          .find({ selector: { equipmentTypeId, isActive: true } })
          .exec();
      } catch (error) {
        console.log('🚀 ~ useEquipment.ts ~ line 113 ~ error', error);
        throw error;
      }
    }

    return assignedEquipment;
  };

  return {
    equipmentInitialized,
    listEquipment,
    listEquipmentOfType,
    listAssignedEquipment,
  };
};

export default useEquipment;
